import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import { Translate, Localize } from 'react-redux-i18n';
import { companyCodeTitle } from '../../actions/root_url';

class GroupManagement extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            groups: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            rowClicked: false,
        };
    }

    componentDidMount() {
        document.title = companyCodeTitle;
        this.props.fetchGroups();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.groups && nextProps.groups != this.props.groups) {
        let newRows = [...nextProps.groups];
        let groups = {...this.state.groups, rows: newRows }
        this.setState({groups});
      }
    }

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid
            let tableHeight = (window.innerHeight < 930) ? 650 : 650;
            const getRows = () => {
                return Data.Selectors.getRows(this.state.groups);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var groups = Object.assign({}, this.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({groups});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.groups.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const groups = {...this.state.groups, filters: newFilters};
                this.setState({ groups });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = this.state.groups.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 var groups = {...this.state.groups, rows: newRows}
                 this.setState({groups});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = this.state.groups.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 // var rowIndexes = rows.map(r => r.rowIdx);
                 var groups = {...this.state.groups, rows: newRows};
                 this.setState({groups});
             }

             const onRowClick = (rowIdx, row) => {
              if (row && !this.state.rowClicked && checkPermission("change_group")) {
                this.setState({ rowClicked: true }, () => {
                 this.props.resetCurrentGroup();
                 this.props.selectCurrentGroup(row.id);
                 this.context.router.push('/groupManagement/' + row.id);
                });
              }
             }

            // Column difinition

            const columns = [
              {
                  key: 'name',
                  name: <Translate value="role_name" />,
                  resizable: true,
                  width: 220,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="GroupManagement-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        minHeight={tableHeight}
                        rowGetter={rowGetter}
                        rowsCount={ getSize() }
                        onRowClick={onRowClick}
                       />
                </div></Col></Row>
            )
        }
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentGroup();
        this.context.router.push('/groupManagement/new');
    }

    render() {
        return (
          //---------------
          // Begin HTML: Create New/Edit role_management
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="admin" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="role_management" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <Grid id="settings-role-management">
                <h1><Translate value="manage_active_roles" /></h1>
                <Panel className="position-relative table-collapse-fix">
                  <ButtonToolbar className="table-buttons">
                    <Button
                        bsStyle="success"
                        className="marginLeftStyle"
                        onClick={(event) => { this.clickNew(event) } } disabled={!checkPermission("add_group")}>
                        <em className="fa fa-plus marginRightStyle" /><Translate value="create_role" />
                    </Button>
                  </ButtonToolbar>
                  { this.renderTable() }
                </Panel>
              </Grid>
            </ContentWrapper>
        )
    }

}

export default GroupManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/groupManagement.jsx